import React from 'react'
import Sidebar from '../components/Sidebar'
import "./Home.css"


const Home = () => {
  return (
    <div className='main-wrapper'>
      <Sidebar/>
    </div>
  )
}

export default Home
